import { Grid } from '@mui/material';
import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { BiFilterAlt } from 'react-icons/bi';
import { CrmJobFilterDTO } from 'wisestep-api';
import {
  WsButton,
  SearchBarNew,
  WsTypography,
  WsTypoColors,
  WsTypoVariants,
  WsColors,
  WsAutoComplete,
} from 'wisestep-base';

import { StyledBox } from '../../../features/clientListingPage/helper/ClientListingHelper';
import { getFilterValue } from '../../../features/notes/helper/NotesHelper';
import SmartFilter from '../../../features/submissionsNew/components/filters/smart/SmartFilter';

interface CrmJobFiltersProps {
  onAdvancedFiltersClick: () => void;
  searchQuery: CrmJobFilterDTO;
  getUpdatedFiltersFromFilters: (query: CrmJobFilterDTO) => void;
  clear: () => void;
  anyJobsSelected: boolean;
  selectedJobsCount: number;
}

const CrmJobFilters = ({
  onAdvancedFiltersClick,
  searchQuery,
  getUpdatedFiltersFromFilters,
  clear,
}: CrmJobFiltersProps) => {
  const methods = useForm({
    defaultValues: {
      query: searchQuery.query || '',
    },
  });
  const { handleSubmit, reset, getValues } = methods;

  const handleClear = () => {
    reset();
    clear();
  };

  const [statusValue, setStatusValue] = useState<string[]>([]);

  const onSearch = () => {
    const query = getValues('query');
    getUpdatedFiltersFromFilters({
      ...searchQuery,
      query,
    });
  };

  const onStatusSelection = (statusInput: string[]) => setStatusValue(statusInput);

  return (
    <StyledBox sx={{ border: 'none' }}>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSearch)}>
          <Grid container bgcolor={WsColors.White}>
            <Grid item xs={4}>
              <SearchBarNew
                size="small"
                name="query"
                placeholder="Search Clients"
                type="submit"
                onClear={handleClear}
              />
            </Grid>
            <Grid item xs>
              <Grid container justifyContent="flex-end" alignItems="center" spacing={1}>
                <Grid item>
                  <WsButton
                    variant="outlined"
                    size="medium"
                    onClick={onAdvancedFiltersClick}
                    startIcon={<BiFilterAlt />}
                  >
                    Advanced filters
                  </WsButton>
                </Grid>
              </Grid>
            </Grid>
            <Grid item container justifyContent="flex-start" alignItems="center" pt={2} spacing={1}>
              <Grid item>
                <WsTypography variant={WsTypoVariants.SUB_TITLE} bold color={WsTypoColors.BLACK}>
                  Applied Filter:
                </WsTypography>
              </Grid>
              <Grid item>
                <SmartFilter
                  filterName="CRM Job status"
                  onClick={onSearch}
                  filterValue={getFilterValue('status', methods)}
                  onClear={clear}
                >
                  <WsAutoComplete
                    key={`status-${statusValue.join(',')}`}
                    onTagsChange={onStatusSelection}
                    placeholder="Eg, Michael"
                    initialValue={statusValue}
                    value={statusValue}
                    optionsInStringArray={[]}
                    multiple={true}
                    freeSolo={true}
                    name="status"
                    size="small"
                  />
                </SmartFilter>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </FormProvider>
    </StyledBox>
  );
};

export default CrmJobFilters;
